export const BASE_URL = 'http://192.168.0.107:3000';


export const IM_CHAT_TYPE_SINGLE     = 'Single';
export const IM_CHAT_TYPE_GROUP      = 'Group';
export const IM_CHAT_TYPE_SYSTEM     = 'System';

export const IM_MESSAGE_TYPE_TEXT    = 'Text';
export const IM_MESSAGE_TYPE_IMAGE   = 'Image';
export const IM_MESSAGE_TYPE_AUDIO   = 'Audio';
export const IM_MESSAGE_TYPE_UNKNOWN = 'Unknown';



// WEBPACK FOOTER //
// ./src/common/im/config.js